import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getEngVideoCompilationEnabled,
  getVideoCompilationEnabled
} from '@src/redux/modules/auth';
import VpButton from '@vp-ui/components/VpButton';
import VpConditionalUpgradeWrapper from '@vp-ui/components/VpConditionalUpgradeWrapper/VpConditionalUpgradeWrapper';
import { useFetchAllCampaigns } from '@src/hooks';

const CreateCompilationButton = ({ enabled, videoCompilationEnabled, ...rest }) => {
  if (!enabled) return <></>;

  const { data } = useFetchAllCampaigns();
  const hasCampaigns = !!data?.length;

  const label =
    'You do not have any campaigns created. Before creating a Video Library please create a campaign.';

  return (
    <VpConditionalUpgradeWrapper
      viewerRestricted
      condition={!videoCompilationEnabled || !hasCampaigns}
      {...(videoCompilationEnabled && !hasCampaigns ? { label } : {})}
    >
      {({ isDisabled }) => (
        <VpButton variant="text" disabled={isDisabled} {...rest}>
          Create Video Library
        </VpButton>
      )}
    </VpConditionalUpgradeWrapper>
  );
};

CreateCompilationButton.propTypes = {
  enabled: PropTypes.bool,
  videoCompilationEnabled: PropTypes.bool
};

const mapStateToProps = (state) => ({
  enabled: getEngVideoCompilationEnabled(state),
  videoCompilationEnabled: getVideoCompilationEnabled(state)
});

export default connect(mapStateToProps)(CreateCompilationButton);



// WEBPACK FOOTER //
// ./src/vp-ui/components/ToPublishingPageButton/CreateCompilationButton.jsx